import React, { useState, useContext } from 'react';
import { getColor, getArrows } from './utils';
import { motion } from 'framer-motion';
import { Tooltip } from '../Tooltip';
import { Portal } from '../Portal';
import { AppContext } from '../../App';

import style from './head-to-head.module.scss';
import { getTrans } from '../../Utils/translate';

// animation settings
const variants = {
  openCenter: (custom) => ({
    opacity: 1,
    y: 0,
    transition: {
      delay: custom.index && custom.index ? custom.index * 0.05 : 0.05
    }
  }),
  closedCenter: { opacity: 0, y: -100 }
};

const CenterCol = ({ config, numberOfZones, leftData, rightData, zoneData }) => {
  const context = useContext(AppContext);
  // Tooltip
  const [coords, setCoords] = useState({});
  const [tooltipOn, setTooltipOn] = useState(false);
  const [delayHandler, setDelayHandler] = useState(null);
  let tooltipIcons = [];
  const lang = context.lang;

  const getTitle = (title) => {
    switch (title) {
      case 'Split':
        return getTrans(lang.split);

      case 'Key Section':
        return getTrans(lang.keySection);

      case 'Downhill':
        return getTrans(lang.downhill);

      case 'Uphill':
        return getTrans(lang.uphill);

      case 'Technical':
        return getTrans(lang.technical);

      default:
        return title;
    }
  };

  if (config.sections && Object.keys(config.sections).length > 0) {
    Object.keys(config.sections).forEach((key) => {
      const content = config.sections[key];
      tooltipIcons.push(
        <div key={`${key}-tooltip`} className={style.tooltipIconLabel}>
          {getTitle(content.title)}
          <img
            className={`${style.icon}`}
            src={content.icon.tooltip ? content.icon.tooltip : content.icon.image}
            alt={content.title}
            style={{
              width: content.icon.tooltipSize
                ? content.icon.tooltipSize[0]
                : content.icon.size[0],
              height: content.icon.tooltipSize
                ? content.icon.tooltipSize.length > 1
                  ? content.icon.tooltipSize[1]
                  : 'auto'
                : content.icon.size.length > 1
                ? content.icon.size[1]
                : 'auto'
            }}
          />
        </div>
      );
    });
  }
  // Tooltip END
  return (
    <>
      {numberOfZones >= 1 &&
        [...Array(numberOfZones)].map((...options) => {
          const index = options[1];
          let leftcolor, rightcolor;

          if (leftData && rightData) {
            leftcolor = getColor(
              leftData[index].zone_time,
              rightData[index].zone_time,
              config.comparisionType === 'lap'
            );
            rightcolor = getColor(
              rightData[index].zone_time,
              leftData[index].zone_time,
              config.comparisionType === 'lap'
            );
          }
          let leftArrow, rightArrow;
          if (config.leaderArrow) {
            const arrows = getArrows(index, leftData, rightData);
            leftArrow = arrows[0];
            rightArrow = arrows[1];
          }
          if (index + 1 > numberOfZones) {
            return false;
          }
          let rightIcon = [];

          if (
            zoneData &&
            zoneData.length > 0 &&
            config.sections &&
            Object.keys(config.sections).length > 0
          ) {
            if (zoneData[index].key_zone) {
              rightIcon.push(
                <img
                  key={`${'key'}-${index}`}
                  className={`${style.icon} ${style.iconRight} ${
                    config.leaderArrow ? '' : style.iconNoArrow
                  }`}
                  src={config.sections['key'].icon.image}
                  alt={config.sections['key'].title}
                  style={{
                    width: config.sections['key'].icon.size[0],
                    height:
                      config.sections['key'].icon.length > 1
                        ? config.sections['key'].icon.size[1]
                        : 'auto'
                  }}
                />
              );
            } else if (zoneData[index].zone_type && zoneData[index].zone_type !== '') {
              const zone = zoneData[index].zone_type;
              rightIcon.push(
                <img
                  key={`${zone}-${index}`}
                  className={`${style.icon} ${style.iconRight} ${
                    config.leaderArrow ? '' : style.iconNoArrow
                  }`}
                  src={config.sections[zone].icon.image}
                  alt={config.sections[zone].title}
                  style={{
                    width: config.sections[zone].icon.size[0],
                    height:
                      config.sections[zone].icon.length > 1
                        ? config.sections[zone].icon.size[1]
                        : 'auto'
                  }}
                />
              );
            }
          }
          return (
            <motion.div
              custom={{
                index: index
              }}
              key={index}
              initial={'closedCenter'}
              animate={'openCenter'}
              variants={variants}
              className={style.zone}>
              {config.colorIndicatorLeft && (
                <span
                  className={`${style.colorIndicator} ${leftcolor} ${
                    config.leaderArrow ? '' : style.noArrows
                  }`}
                ></span>
              )}
              {!config.colorIndicatorLeft && (
                <span
                  className={`${style.colorIndicator} ${style.noArrows}`}
                  style={{ backgroundColor: 'var(--cosmos-color-surface-glass-light-10)'}}></span>
              )}
              <div
                className={`${style.centerColInfo} ${
                  config.leaderArrow ? '' : style.noArrows
                }`}
                onMouseEnter={(e) => {
                  const rect = e.target.getBoundingClientRect();
                  setCoords({
                    left: rect.x + rect.width / 2,
                    top: rect.y + window.scrollY
                  });
                  setDelayHandler(
                    setTimeout(() => {
                      setTooltipOn(true);
                    }, 500)
                  );
                }}
                onMouseLeave={() => {
                  clearTimeout(delayHandler);
                  setTooltipOn(false);
                }}>
                {config.leaderArrow && (
                  <span className={`${style.leftArrow} ${leftArrow}`}></span>
                )}
                {zoneData &&
                  zoneData.length > 0 &&
                  config.sections &&
                  config.sections.split &&
                  zoneData[index].split_zone && (
                    <img
                      className={`${style.icon} ${style.iconLeft} ${
                        config.leaderArrow ? '' : style.iconNoArrow
                      }`}
                      src={config.sections.split.icon.image}
                      alt={config.sections.split.title}
                      style={{
                        width: config.sections.split.icon.size[0],
                        height:
                          config.sections.split.icon.size.length > 1
                            ? config.sections.split.icon.size[1]
                            : 'auto'
                      }}
                    />
                  )}
                {zoneData && zoneData[index].zone}
                {rightIcon}
                {config.leaderArrow && (
                  <span className={`${style.rightArrow} ${rightArrow}`}></span>
                )}
              </div>

              {config.colorIndicatorRight && (
                <span
                  className={`${style.colorIndicator} ${rightcolor} ${
                    config.leaderArrow ? '' : style.noArrows
                  }`}
                ></span>
              )}
              {!config.colorIndicatorRight && (
                <span
                  className={`${style.colorIndicator} ${style.noArrows}`}
                  style={{ backgroundColor: 'var(--cosmos-color-surface-glass-light-10)'}}></span>
              )}
            </motion.div>
          );
        })}
      {tooltipOn && (
        <Portal>
          <Tooltip coords={coords}>
            <div className={style.tooltipIcons}>{tooltipIcons}</div>
          </Tooltip>
        </Portal>
      )}
    </>
  );
};
export { CenterCol };
